import React, { FunctionComponent, useState } from 'react';

import classnames from 'classnames';
import { useTranslation } from 'react-i18next';

interface Props {
    fieldLabel: string;
    className: string;
}
export const FieldWrapper: FunctionComponent<Props> = ({ fieldLabel, className, children }) => {
    const { t } = useTranslation(['social/publisher']);
    const [isActive, setIsActive] = useState(false);

    return (
        <div className={`post-target-field ${className}`}>
            <div
                className="post-target-field-title"
                role="button"
                aria-label="Expand Option"
                tabIndex={0}
                onKeyPress={(): void => {
                    // Do Nothing
                }}
                onClick={(): void => {
                    const newIsActive = !isActive;

                    setIsActive(newIsActive);
                }}
            >
                <div className="target-field-label">{t(fieldLabel)}</div>
                <div className="target-field-icon">
                    {isActive ? <i className="icon-angle-down" /> : <i className="icon-angle-right" />}
                </div>
            </div>
            <div className={classnames('post-target-field-options', { show: isActive })}>{children}</div>
        </div>
    );
};
